export default {

  getEmpresas({ empresas }) {
    return empresas
  }

}
